
// 本地枚举json
import mjJson from '../../static/js/meiju.json'
import moment from 'moment'
moment.locale('zh-cn');

import formMoney from '../../../src/static/js/utils/modules/formMoney.js'
/**
 * 展示输入
 * @param form
 * @returns
 * {'标题':'输入值'}
 */
export default (form) => {
  let f = {};
  for (let key in form) {
    let item = form[key];

    try{
        if(item.hide){
            continue;
        }
    }catch (e) {

    }


    try{
        if(item.value === null || item.value === undefined || item.value === ''){
            f[item['label']] = '无'
        }else {
            switch (item.type) {
                /*日期*/
                case 'date':
                    let output = 'YYYY年M月D日';
                    if (item.dateType == 'month') {
                        output = 'YYYY年M月';
                        item.value = item.value.length === 6 ? item.value.slice(0, 4) + '-' + item.value.slice(4) : item.value

                    } else if (item.dateType == 'year') {
                        output = 'YYYY年'
                    }
                    f[item['label']]  = moment(item.value).format(output);
                    break;
                /*本地枚举*/
                case 'mj':
                    let mjValue = '';
                    mjJson[item.mj].map( i => {
                        if(i.code == item.value){
                            mjValue = i.name
                        }
                    });
                    f[item['label']] = mjValue;
                    break;
                /*自定义选择框*/
                case 'select':
                    let slValue = '';
                    item.select.map( i => {
                        if(i.code == item.value){
                            slValue = i.name
                        }
                    });
                    f[item['label']] = slValue;
                    break;
                /*单选框*/
                case 'radio':
                    let raValue = '';
                    item.radio.map( i => {
                        if(i.code == item.value){
                            raValue = i.name
                        }
                    });
                    f[item['label']] = raValue;
                    break;
                /*其他*/
                default :
                    f[item['label']]  = item.value;
                    break
            }

            if(item.append){
                if(item.append == '元'){
                    f[item['label']] = formMoney( f[item['label']] ) + item.append;
                }else {
                    f[item['label']]  += item.append;
                }
            }
        }
    }catch (e) {
        f[item['label']] = '无'
    }


  }
  return f
}




// WEBPACK FOOTER //
// ./src/components/s-input/showSItem.js